import React from "react";
import { Box, Button, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { COLORS, FONT } from "../../constants";

const ConfirmationStep = ({ isMobile }) => {
  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        py: 6,
        px: isMobile ? 0 : 3,
        gap: 2,
      }}
    >
      <CheckCircleOutlineIcon
        sx={{ fontSize: 64, color: "#2e7d32", mb: 1 }}
      />

      <Typography
        sx={{
          fontWeight: 700,
          fontSize: isMobile ? FONT.size.xl : FONT.size.h3,
          color: COLORS.themeBlack,
          lineHeight: 1.3,
        }}
      >
        Application Submitted!
      </Typography>

      <Typography
        sx={{
          fontSize: isMobile ? FONT.size.xs : FONT.size.sm,
          color: COLORS.lightText,
          lineHeight: 1.8,
          maxWidth: 380,
        }}
      >
        Thank you for applying for a Trade Account with Argus. Our team will
        review your application and get back to you within{" "}
        <Box component="span" sx={{ fontWeight: 600, color: COLORS.darkText }}>
          24–48 hours
        </Box>
        .
      </Typography>

      <Box
        sx={{
          backgroundColor: "#f9f9f9",
          border: "1px solid #e8e8e8",
          borderRadius: "4px",
          px: 3,
          py: 2,
          maxWidth: 380,
          width: "100%",
        }}
      >
        <Typography
          sx={{
            fontSize: isMobile ? FONT.size.xs : FONT.size.sm,
            color: COLORS.darkText,
            lineHeight: 1.8,
          }}
        >
          In the meantime, you&apos;re welcome to browse and shop at{" "}
          <Box component="span" sx={{ fontWeight: 600 }}>
            retail pricing
          </Box>{" "}
          — your trade pricing will be activated once your account is approved.
        </Typography>
      </Box>

      <Button
        variant="contained"
        href="/products/parts"
        sx={{
          mt: 1,
          backgroundColor: COLORS.themeRed,
          color: COLORS.white,
          fontWeight: 600,
          px: 5,
          py: 1.5,
          borderRadius: "2px",
          textTransform: "none",
          fontSize: isMobile ? FONT.size.sm : FONT.size.md,
          boxShadow: "none",
          width: isMobile ? "100%" : "auto",
          "&:hover": { backgroundColor: COLORS.themeRed, boxShadow: "none" },
        }}
      >
        Shop Now
      </Button>
    </Box>
  );
};

export default ConfirmationStep;
